<template>
  <div>
    <el-dialog title="新增禁言关键词" center :visible="true" @close="onClose" :close-on-click-modal="false"
      :close-on-press-escape="false" width="400px">
      <el-form ref="form" :model="form"   label-width="120px" size="mini">
        <el-input type="textarea" rows="10" v-model="form.text" placeholder="可输入多个关键词，每行1个"
            style="width: 350px"   ></el-input>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "AddChatBanKeywordsDialog";

export default {
  data() {
    return {
      form: {
        text: "",
      }
    };
  },

  created() {
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      this.addChatBan();
    },

    /**
     * 新增禁言关键词
     */
    async addChatBan() {
      let parseResult = this.parseWords();
        if (parseResult.err) {
          this.$message({
            message: parseResult.err,
            type: "error",
          });
          return;
        }

        let words = parseResult.list;


      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/addChatBanKeywords`,
          {
            words: words,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      this.$message({
        message: "添加成功",
        type: "success",
      });

      // 关闭当前对话框
      this.onClose();
    },

      /**
     * 解析关键字集合
     *
     * @returns {list: [], err: "xxxx"}
     */
     parseWords() {
      let list = [];

      let wordsText = this.form.text.trim();
      if (wordsText.length > 0) {
        let arr = wordsText.split(/\s+/);
        for (let e of arr) {
          let word = e.trim();

          if (word.length <= 0) {
            return {
              list: [],
              err: "关键字不能为空",
            };
          }

          list.push(word);
        }
      }

      if (list.length == 0) {
        return {
          list: [],
          err: "请输入关键字",
        };
      }

      return {
        list: list,
      };
    },

    onClose() {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>